import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconCheck16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "m13.064 5.494-5.722 6.54-4.31-3.448.937-1.172 3.19 2.552 4.777-5.46z",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgIconCheck16);
export default ForwardRef;
